
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OvertimeStatsBulk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"period"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PeriodInput"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkOverTimeStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"period"},"value":{"kind":"Variable","name":{"kind":"Name","value":"period"}}},{"kind":"Argument","name":{"kind":"Name","value":"workspaceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceIds"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspaceId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"usedTimeOffInLieuMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentPendingTimeOffInLieuMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"employeeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"employeeName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overTimeAgreedMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overTimeOrderedMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overTimePaidMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overTimePaidTOILMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overTimeTotalMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overTimeUnpaidMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overTimeAgreedPaidMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overTimeAgreedUnpaidMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overTimeOrderedPaidMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overTimeOrderedUnpaidMinutes"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":713}};
    doc.loc.source = {"body":"query OvertimeStatsBulk(\n  $organizationId: ID!\n  $period: PeriodInput!\n  $workspaceIds: [ID!]!\n) {\n  organization(id: $organizationId) {\n    bulkOverTimeStats(period: $period, workspaceIds: $workspaceIds) {\n      workspaceId\n      stats {\n        userId\n        usedTimeOffInLieuMinutes\n        currentPendingTimeOffInLieuMinutes\n        employeeId\n        employeeName\n        overTimeAgreedMinutes\n        overTimeOrderedMinutes\n        overTimePaidMinutes\n        overTimePaidTOILMinutes\n        overTimeTotalMinutes\n        overTimeUnpaidMinutes\n        overTimeAgreedPaidMinutes\n        overTimeAgreedUnpaidMinutes\n        overTimeOrderedPaidMinutes\n        overTimeOrderedUnpaidMinutes\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["OvertimeStatsBulk"] = oneQuery(doc, "OvertimeStatsBulk");
        
